import { DefaultTheme } from 'styled-components';

import colors from './colors';

const defaultTheme: DefaultTheme = {
  space: (value: number) => value * 10 + 'px',
  colors: {
    ...colors,
    // Ensure all required colors are present or add default values
    primaryBlue: colors.primaryBlue || '#316EF7',
    darkBlue: colors.darkBlue || '#292935',
    white: colors.white || '#FFFFFF',
    secondaryBlue: colors.secondaryBlue || '#535374',
    gradientOlybet: colors.gradientOlybet || 'linear-gradient(...)',
    primaryRed: colors.primaryRed || '#F73535',
    darkGoku: colors.darkGoku || '#19191C',
    greyText: colors.greyText || '#999999',
    primaryBrown: colors.primaryBrown || '#231F20',
    OlybetSecondaryBlue: colors.OlybetSecondaryBlue || '#33CFFF',
    OlybetGrey07: colors.OlybetGrey07 || '#BDBDBD', // Assuming a default grey
  },
};

export default defaultTheme;
